module.exports = __webpack_public_path__ + "static/media/space_starman.368ef034.png";